import { render, staticRenderFns } from "./CodeForm.vue?vue&type=template&id=1c87d9f6&"
import script from "./CodeForm.vue?vue&type=script&lang=ts&"
export * from "./CodeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports